webpackJsonp([3],{

/***/ 1155:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/comic.png";

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: none;\n  letter-spacing: 0;\n  margin: 1.25em;\n  font-size: 1em;\n  text-decoration: none;\n'], ['\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: none;\n  letter-spacing: 0;\n  margin: 1.25em;\n  font-size: 1em;\n  text-decoration: none;\n']);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(36);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = __webpack_require__(147);

var _components = __webpack_require__(231);

var _theme = __webpack_require__(40);

var _comic = __webpack_require__(1155);

var _comic2 = _interopRequireDefault(_comic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Error404__Wrapper'
})(['display:flex;flex-direction:column;width:600px;max-width:85%;margin:0 auto;font-family:NexaLight;']);

var ErrorHeading = _styledComponents2.default.h1.withConfig({
  displayName: 'Error404__ErrorHeading'
})(['text-align:center;font-family:NexaBold;font-size:5em;color:', ';'], _theme.colors.primary);

var ErrorDescription = _styledComponents2.default.p.withConfig({
  displayName: 'Error404__ErrorDescription'
})(['text-align:center;line-height:1.5;font-weight:400;margin-top:0;margin-bottom:3em;']);

var ErrorLink = _styledComponents2.default.a.withConfig({
  displayName: 'Error404__ErrorLink'
})(['color:', ';text-decoration:none;cursor:pointer;&:hover{text-decoration:underline;}'], _theme.colors.primary);

var ComicContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Error404__ComicContainer'
})(['align-self:center;display:flex;flex-direction:column;']);

var ComicImage = _styledComponents2.default.img.withConfig({
  displayName: 'Error404__ComicImage'
})(['width:450px;max-width:100%;']);

var ComicCite = _styledComponents2.default.cite.withConfig({
  displayName: 'Error404__ComicCite'
})(['margin:1.5em 0;font-size:.85em;font-style:normal;']);

var ButtonContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Error404__ButtonContainer'
})(['display:flex;justify-content:center;']);

var Button = _components.PrimaryButton.extend(_templateObject);

var LinkButton = Button.withComponent('a');

function Error404() {
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(
      ErrorHeading,
      null,
      '404'
    ),
    _react2.default.createElement(
      ErrorDescription,
      null,
      'We can\u2019t seem to find this page. Please enjoy this comic before',
      ' ',
      _react2.default.createElement(
        ErrorLink,
        { onClick: function onClick() {
            return window.history.back();
          } },
        'going back'
      ),
      ' ',
      'or ',
      _react2.default.createElement(
        ErrorLink,
        { href: 'https://resumake.io' },
        'going home'
      ),
      '.'
    ),
    _react2.default.createElement(
      ComicContainer,
      null,
      _react2.default.createElement(ComicImage, { src: _comic2.default, alt: 'Resume Comic' }),
      _react2.default.createElement(
        ComicCite,
        null,
        'Credit: Bob Eckstein (bobeckstein.com)'
      )
    ),
    _react2.default.createElement(
      ButtonContainer,
      null,
      _react2.default.createElement(
        Button,
        { onClick: function onClick() {
            return window.history.back();
          } },
        'Go Back'
      ),
      _react2.default.createElement(
        LinkButton,
        { href: 'https://resumake.io' },
        'Go Home'
      )
    )
  );
}

exports.default = Error404;

/***/ })

});


// WEBPACK FOOTER //
// 3.static/bundle.js